import { render } from "./Qrpayment.vue?vue&type=template&id=7dc66dd3"
import script from "./Qrpayment.vue?vue&type=script&lang=js"
export * from "./Qrpayment.vue?vue&type=script&lang=js"
script.render = render

export default script